import { Helmet } from 'react-helmet';
import NoPrerender from '~/modules/Elements/NoPrerender';
import useSmoothNavigate from '~/modules/hooks/useSmoothNavigate';
import ExcludeLanguagesView from './ExcludeLanguagesView';

function ExcludeLanguages() {
  const navigate = useSmoothNavigate();
  const goBack = () => navigate('');

  return (
    <>
      <Helmet>
        <title>Select Languages | fastKaraoke</title>
      </Helmet>
      <NoPrerender>
        <ExcludeLanguagesView onClose={goBack} closeText="Return to Song List" />
      </NoPrerender>
    </>
  );
}

export default ExcludeLanguages;
